import {
  PaymentModesEnumType,
  PaymentServicesEnumType
} from '@nw/shared/data-access';

import { PaymentGatewayType } from '../../types/storesTypes';

class PaymentGateway {
  paymentService!: PaymentServicesEnumType;
  paymentServiceDescription!: string;
  paymentModes!: PaymentModesEnumType[];

  constructor(paymentGateway: PaymentGatewayType) {
    this.paymentService = paymentGateway.payment_service;
    this.paymentServiceDescription = paymentGateway.payment_service_description;
    this.paymentModes = JSON.parse(paymentGateway.payment_modes);
  }
}

export default PaymentGateway;
